import { getId } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { AnswerColumnEffectiveType, } from '../types';
export const getQueryIndex = (col) => col.queryIndex;
export const getDataRowIndex = (col) => col.dataRowIndex;
export const areColumnsEqual = (columnArrayA, columnArrayB) => {
    if (columnArrayA.length !== columnArrayB.length) {
        return false;
    }
    return _.reduce(columnArrayA, (areEqual, col, idx) => {
        if (_.isNil(columnArrayA[idx]) && _.isNil(columnArrayB[idx])) {
            return areEqual;
        }
        return (areEqual &&
            !_.isNil(columnArrayA[idx]) &&
            !_.isNil(columnArrayB[idx]) &&
            getId(columnArrayA[idx]) === getId(columnArrayB[idx]));
    }, true);
};
export function areAxisConfigEqual(axisConfigA, axisConfigB) {
    const axisPropKeys = _.keys(_.omit(axisConfigA, '__typename'));
    for (const [i, key] of axisPropKeys.entries()) {
        const isEqual = _.isEqualWith(_.isArray(axisConfigB[key])
            ? axisConfigB[key]
            : _.compact([axisConfigB[key]]), _.isArray(axisConfigA[key])
            ? axisConfigA[key]
            : _.compact([axisConfigA[key]]), areColumnsEqual);
        if (!isEqual) {
            return isEqual;
        }
    }
    return true;
}
export function getTooltipColumns(queryDefinitions, tooltipColumnIds, vizColumns, baseQueryIndex) {
    if (!tooltipColumnIds) {
        return [];
    }
    const baseQueryDefinition = queryDefinitions[baseQueryIndex];
    const baseQueryAxisConfigColumns = baseQueryDefinition.getColumnsInDataOrder();
    const otherAxisConfigColumns = [];
    queryDefinitions.forEach((queryDefinition, index) => {
        if (index !== baseQueryIndex) {
            const axisConfigColumns = queryDefinition.getColumnsInDataOrder();
            otherAxisConfigColumns.push(...axisConfigColumns);
        }
    });
    let extraColumnsCount = 0;
    const tooltipColumns = tooltipColumnIds.map((colId, index) => {
        var _a;
        const columnInAxisConfig = baseQueryAxisConfigColumns.find((col) => col.id === colId);
        if (columnInAxisConfig) {
            return columnInAxisConfig;
        }
        const columnInOtherAxisConfig = otherAxisConfigColumns.find((axisConfigColumn) => axisConfigColumn.id === colId);
        const isColumnAttributeType = columnInOtherAxisConfig &&
            columnInOtherAxisConfig.type ===
                AnswerColumnEffectiveType.Attribute;
        if (isColumnAttributeType) {
            return undefined;
        }
        const answerColumn = (_a = vizColumns.find((col) => col.column.id === colId)) === null || _a === void 0 ? void 0 : _a.column;
        if (!answerColumn) {
            return null;
        }
        const axisConfigColumn = {
            ...answerColumn,
            dataRowIndex: baseQueryAxisConfigColumns.length + extraColumnsCount++,
            queryIndex: baseQueryIndex,
        };
        return axisConfigColumn;
    });
    return _.compact(tooltipColumns);
}
//# sourceMappingURL=axis-config-util.js.map